'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _UICloseButton = require('../button/UICloseButton');

var _UICloseButton2 = _interopRequireDefault(_UICloseButton);

var _Functions = require('../core/Functions');

var _colors = require('HubStyleTokens/colors');

var _DistanceConstants = require('../layout/DistanceConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UITile = _react2.default.createClass({
  displayName: 'UITile',

  propTypes: {
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    closeable: _react.PropTypes.bool.isRequired,
    compact: _react.PropTypes.bool.isRequired,
    distance: _react.PropTypes.oneOf(Object.keys(_DistanceConstants.DISTANCE_CLASSES)),
    onClose: _react.PropTypes.func
  },

  getDefaultProps: function getDefaultProps() {
    return {
      closeable: false,
      compact: false
    };
  },
  getClassName: function getClassName() {
    var _props = this.props,
        className = _props.className,
        compact = _props.compact,
        distance = _props.distance;

    return (0, _reactUtils.classNames)('private-tile', _DistanceConstants.DISTANCE_CLASSES[distance], {
      'private-tile--compact': compact,
      'private-tile--spaced': !distance
    }, className);
  },
  handleCloseButtonClick: function handleCloseButtonClick(evt) {
    (0, _Functions.callIfPossible)(this.props.onClose, evt);
  },
  renderCloseButton: function renderCloseButton(_ref) {
    var closeable = _ref.closeable;

    if (!closeable) {
      return null;
    }

    return _react2.default.createElement(_UICloseButton2.default, {
      color: _colors.FLINT,
      className: 'private-tile__close',
      onClick: this.handleCloseButtonClick,
      size: 'small'
    });
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        closeable = _props2.closeable,
        __compact = _props2.compact,
        __distance = _props2.distance,
        __onClose = _props2.onClose,
        rest = _objectWithoutProperties(_props2, ['children', 'closeable', 'compact', 'distance', 'onClose']);

    return _react2.default.createElement(
      'div',
      _extends({}, rest, { className: this.getClassName() }),
      this.renderCloseButton({ closeable: closeable }),
      children
    );
  }
});

exports.default = UITile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/tile/UITile.js
// module id = 487
// module chunks = 0